<template>
    <div class="locale-changer">
        <v-select prepend-icon="mdi-flag" v-model="$i18n.locale" :items="locales" item-text="label" item-value="value"></v-select>
    </div>
</template>
<script>
export default
{
    name: 'LanguageSwitcher',    
    computed:
    {  	
        locales()
        {            
            let languages = []            
            let keys = Object.keys(this.$i18n.messages);
            for (let key of keys)
            {
                languages.push({label: this.$t(key), value:key});
            }            
            return languages;
        },
        currentLocale()
        {
            return this.$i18n.locale;
        }
    },

    mounted: function()
    {        
        let language = navigator.language || navigator.userLanguage
        if (language)
        {
            let lang = language.split("-")[0];
            if (lang && this.$i18n.availableLocales.indexOf(lang) >= 0)
            {
                this.$i18n.locale = lang;
                this.$store.state.locale = lang;
            }
        }


    },
    watch:
    {
        currentLocale: function(newValue)
        {
            this.$store.state.locale = newValue;
        }
    },
};
</script>